<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';
import RbxTextEditor from '../../../shared/reybex/RbxTextEditor';

export default {
  name: 'NewEmployeeDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        username: { required: true },
        password: { required: true },
      },
      baseFormData: {
        salutation: '',
        firstname: '',
        surname: '',
        phone: '',
        mobile: '',
        department: '',
        email: '',
        comment: '',
      },
      formData: {},
    };
  },
  created() {
    this.formData = cloneDeep(this.baseFormData);
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('employeeDetails', ['saveEmployee']),
    ...mapActions('employeeList', { fetchData: 'fetchEmployeeList' }),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return this.saveEmployee(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('Mitarbeiter erfolgreich erstellt!');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/employee/${data.id}`);
            }
          }
          this.fetchData();
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Fehler beim erstellen des Mitarbeiters. Bitte versuche es erneut!');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neuer Mitarbeiter
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>
              <h4 class="employee-detail-tab-title">Stammdaten</h4>
              <v-layout row wrap>

                <v-flex xs12 md4 py-0>
                  <rbx-remote-combobox
                    v-model="formData.salutation"
                    label="Anrede"
                    height="22"
                    domain="salutation"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.firstname"
                    label="Vorname"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.surname"
                    label="Nachname"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.phone"
                    label="Telefon"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.mobile"
                    label="Handy"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.email"
                    label="E-Mail-Adresse"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md4 py-0>
                  <rbx-remote-combobox
                    v-model="formData.department"
                    label="Abteilung"
                    height="22"
                    domain="department"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md12 py-0>
                  <rbx-text-editor
                    label="Notiz"
                    v-model="formData.comment"
                  />
                </v-flex>

              </v-layout>

              <h4 class="employee-detail-tab-title">Administration</h4>
              <v-layout row wrap>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.username"
                    :error-messages="validationErrorMessages.username"
                    label="Benutzername"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.password"
                    :error-messages="validationErrorMessages.password"
                    label="Passwort"
                    height="22"
                    class="caption"
                    type="password"
                  />
                </v-flex>

              </v-layout>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

        <v-menu bottom left>
          <v-btn slot="activator" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile>
              <v-list-tile-title @click="submit('new')">
                Speichern &amp; Neu
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-title @click="submit('detail')">
                Speichern &amp; Detail
              </v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
